// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-permission-wrapper[data-v-2597f068] {\n  display: inline-block;\n}", "",{"version":3,"sources":["webpack://./resources/js/components/NoPermissionWrapper.vue"],"names":[],"mappings":"AACA;EACE,qBAAA;AAAF","sourcesContent":["\n.no-permission-wrapper {\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
